import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from '@/components/shadcn/form'
import { Button } from '@/components/shadcn/button'
import { Calendar } from '@/components/shadcn/calendar'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/shadcn/popover'
import { format } from 'date-fns'
import { cn } from '@/lib/utils'
import { BaseFieldProps } from './types'
import { IconCalendarOutline } from '@/components/icons'
import clsx from 'clsx'

export const DateField: React.FC<BaseFieldProps> = ({ field, formFieldName, control }) => {
  return (
    <FormField
      control={control}
      name={formFieldName}
      render={({ field: formField }) => (
        <FormItem className={clsx('flex flex-1 flex-col', field.widget === 'hidden' && 'hidden')}>
          <FormLabel>{field.title}</FormLabel>
          <Popover>
            <PopoverTrigger asChild>
              <FormControl>
                <Button
                  variant="outline"
                  className={cn('w-full pl-3 text-left font-normal', !formField.value && 'text-muted-foreground')}
                  disabled={field.readonly}
                >
                  {formField.value ? format(new Date(formField.value as string), 'PP') : <span>Pick a date</span>}
                  <IconCalendarOutline className="ml-auto size-5" />
                </Button>
              </FormControl>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0" align="start">
              <Calendar
                mode="single"
                selected={formField.value ? new Date(formField.value as string) : undefined}
                onSelect={(date) => {
                  if (date) {
                    const formattedDate = format(date, field.format === 'date' ? 'yyyy-MM-dd' : "yyyy-MM-dd'T'HH:mm:ss")
                    formField.onChange(formattedDate)
                  }
                }}
                initialFocus
              />
            </PopoverContent>
          </Popover>
          <FormDescription>{field.description}</FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}
